import React from 'react';
import { motion } from 'motion/react';
import { VIEWPORT } from '../../lib/motion-presets';

/**
 * <SectionDivider> — animated gold accent line between sections.
 * Draws from left to right on scroll entry.
 */
const SectionDivider = ({ className = '' }) => (
  <div
    className={`section-divider-wrap ${className}`}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      margin: '0 auto',
      maxWidth: '320px',
    }}
  >
    <motion.div
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={VIEWPORT}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      style={{
        height: '1px',
        flex: 1,
        background: 'var(--dual-accent-gradient)',
        transformOrigin: 'left',
      }}
    />
    <motion.span
      initial={{ scale: 0, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={VIEWPORT}
      transition={{ duration: 0.4, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
      style={{
        color: 'var(--gold-400)',
        fontSize: '10px',
        lineHeight: 1,
        flexShrink: 0,
      }}
      aria-hidden="true"
    >
      ✦
    </motion.span>
    <motion.div
      initial={{ scaleX: 0, opacity: 0 }}
      whileInView={{ scaleX: 1, opacity: 1 }}
      viewport={VIEWPORT}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      style={{
        height: '1px',
        flex: 1,
        background: 'var(--dual-accent-gradient)',
        transformOrigin: 'right',
      }}
    />
  </div>
);

export default SectionDivider;
